import { useDispatch, useSelector } from 'react-redux';
import { isEmpty } from 'lodash';
import { useEffectOnce } from 'usehooks-ts';

import { provincesFetch } from './action';
import { selectFeatureProvince } from './selector';

export const useProvincesFetch = () => {
  const dispatch = useDispatch();
  const { provinces } = useSelector(selectFeatureProvince);

  useEffectOnce(() => {
    if (!isEmpty(provinces)) return;
    dispatch(provincesFetch());
  });

  return provinces;
};
